import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import isEmpty from 'lodash/isEmpty';

import {types as sdkTypes, createImageVariantConfig, util as sdkUtil} from '../util/sdkLoader';
import { findNextBoundary, getStartOf, monthIdString } from '../util/dates';
import { isTransactionsTransitionInvalidTransition, storableError } from '../util/errors';
import {
  transactionLineItems,
  uploadFiles,
  deleteFile,
} from '../util/api';
import * as log from '../util/log';
import {
  updatedEntities,
  denormalisedEntities,
  denormalisedResponseEntities,

} from '../util/data';
import {
  resolveLatestProcessName,
  getProcess,
  isBookingProcess,
} from '../transactions/transaction';

import { addMarketplaceEntities } from './marketplaceData.duck';
import { fetchCurrentUserNotifications } from './user.duck';
import {showListing} from "../containers/ListingPage/ListingPage.duck";

const { UUID } = sdkTypes;

const MESSAGES_PAGE_SIZE = 100;
const REVIEW_TX_INCLUDES = ['reviews', 'reviews.author', 'reviews.subject'];

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/TransactionPage/SET_INITIAL_VALUES';

export const UPLOAD_FILE_REQUEST = 'app/TransactionPage/UPLOAD_FILE_REQUEST';
export const UPLOAD_FILE_SUCCESS = 'app/TransactionPage/UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_ERROR = 'app/TransactionPage/UPLOAD_FILE_ERROR';

export const DELETE_FILE_REQUEST = 'app/TransactionPage/DELETE_FILE_REQUEST';
export const DELETE_FILE_SUCCESS = 'app/TransactionPage/DELETE_FILE_SUCCESS';
export const DELETE_FILE_ERROR = 'app/TransactionPage/DELETE_FILE_ERROR';

export const UPLOAD_SUCCESS = 'app/TransactionPage/UPLOAD_SUCCESS';

// ================ Reducer ================ //

const initialState = {
  uploadFileInProgress: false,
  uploadFileError: null,
  uploadSuccess: null,
  files: [],
  deleteFileInProgress: false,
  deleteFileError: false,
};

// Merge entity arrays using ids, so that conflicting items in newer array (b) overwrite old values (a).
// const a = [{ id: { uuid: 1 } }, { id: { uuid: 3 } }];
// const b = [{ id: : { uuid: 2 } }, { id: : { uuid: 1 } }];
// mergeEntityArrays(a, b)
// => [{ id: { uuid: 3 } }, { id: : { uuid: 2 } }, { id: : { uuid: 1 } }]
const mergeEntityArrays = (a, b) => {
  return a.filter(aEntity => !b.find(bEntity => aEntity.id.uuid === bEntity.id.uuid)).concat(b);
};

export default function transactionPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };


    case UPLOAD_FILE_REQUEST:
      return { ...state, uploadFileInProgress: true, uploadFileError: null, uploadSuccess: null };
    case UPLOAD_FILE_SUCCESS:
      return { ...state, uploadFileInProgress: false, uploadFileError: null, files: payload };
    case UPLOAD_FILE_ERROR:
      return { ...state, uploadFileInProgress: false, uploadFileError: payload };

    case DELETE_FILE_REQUEST:
      return { ...state, deleteFileInProgress: true, deleteFileError: null };
    case DELETE_FILE_SUCCESS:
      return { ...state, deleteFileInProgress: false, deleteFileError: null, files: payload };
    case DELETE_FILE_ERROR:
      return { ...state, deleteFileInProgress: false, deleteFileError: payload };

    case UPLOAD_SUCCESS:
      return { ...state, uploadSuccess: payload };

    default:
      return state;
  }
}

// ================ Selectors ================ //

export const transitionInProgress = state => {
  return state.TransactionPage.transitionInProgress;
};

// ================ Action creators ================ //
export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});


export const uploadFileRequest = () => ({ type: UPLOAD_FILE_REQUEST });
export const uploadFileSuccess = payload => ({ type: UPLOAD_FILE_SUCCESS, payload: payload?.data });
export const uploadFileError = error => ({ type: UPLOAD_FILE_ERROR, payload: error });

export const deleteFileRequest = () => ({type: DELETE_FILE_REQUEST,});
export const deleteFileSuccess = payload => ({type: DELETE_FILE_SUCCESS, payload: payload?.data,});
export const deleteFileError = error => ({type: DELETE_FILE_ERROR, payload: error,});

// ================ Thunks ================ //

const config = {
  layout: {
    listingImage: {
      aspectWidth: 1,
      aspectHeight: 1,
      variantPrefix: 'listing-card',
    }
  }
};

export const uploadFilesTx = (files, id, userRole, entity, mediaName) => (dispatch, getState, sdk) => {
  dispatch(uploadFileRequest());
  const formData = new FormData();

  for (let file in files) {
    if (typeof files[file] === 'object') {
      formData.append('files', files[file]);
    }
  }

  formData.append('id', id);
  formData.append('userRole', userRole);
  formData.append('entity', entity);
  formData.append('mediaName', mediaName);

  return uploadFiles(formData)
    .then(res => {
      dispatch(uploadFileSuccess(res?.data));

      if(entity === 'listing') {
        dispatch(showListing(id, config, false));
      }

      return res?.data
    })
    .catch(e => {
      dispatch(uploadFileError(e?.response?.data?.error));
    });
};

export const deleteFileTx = (key, id, entity, mediaName) => async dispatch => {
  dispatch(deleteFileRequest());
  return deleteFile(key, id, entity, mediaName)
    .then(res => {
      dispatch(deleteFileSuccess(res?.data))
      if(entity === 'listing') {
        dispatch(showListing(id, config, false));
      }
      return res?.data
    })
    .catch(e => dispatch(deleteFileError(e)));
};
